export default {
  name: "Respond to NRM",
  pageInfo: {
    text: "Please upload the response to your Notice of Required Modification below. Your response will be added to the case documents and directed to an analyst for review.",
    coloring: "grey",
  },
  sections: [
    {
      fields: [
        {
          machine_name: "fileType",
          value: "NRM Response",
          widget: "text",
          style: {
            display: "none",
          },
        },
        {
          machine_name: "files",
          widget: "file_upload",
          file_upload: { fileType: "NRM_Response_Document_Upload" },
          accept_multiple: false,
          required: true,
          validate: ["required", "file_required"],
          checkFilesAdded: true,
          documentAuth: "dh",
        },
        {
          machine_name: "document_description",
          widget: "text",
          label: "Document Description",
          validate: ["required"],
          maxLength: 100,
        },
        // {
        //     machine_name: 'case_note',
        //     widget: 'text_area',
        //     label: 'Case Note',
        //     inputLimit: 400,
        //     rows: 7
        // }
      ],
    },
  ],
};
